<div
  *ngIf="showModal"
  class="detailsModal no-scroll"
  (click)="onBackdropClick($event)"
>
  <div
    class="box"
    [style.width]="width"
    [style.max-width]="maxWidth"
    [style.max-height]="maxHeight"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="modal-details-header">
      <h4 style="font-size: 18px; font-weight: 600; margin: 0;">
        {{ title | translate }}
      </h4>
      <span
        *ngIf="!hideClose"
        class="close-icon"
        (click)="close.emit()"
        aria-label="Close"
        title="Close"
      >
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
    </div>

    <!-- Content -->
    <div class="modal-details-content">
      <ng-content></ng-content>
    </div>

    <!-- Footer -->
    <div class="modal-details-footer" *ngIf="showFooter">
      <button
        *ngIf="showSecondaryButton"
        type="button"
        [class]="secondaryButtonClass"
        (click)="secondaryAction.emit()"
      >
        {{ secondaryButtonText | translate }}
      </button>

      <button
        type="button"
        [class]="primaryButtonClass"
        (click)="primaryAction.emit()"
        [disabled]="primaryButtonDisabled"
        [class.disabled]="primaryButtonDisabled"
      >
        {{ primaryButtonText | translate }}
      </button>
    </div>
  </div>
</div>